import React, { useEffect, useState } from "react";

export default function Checkout() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 relative transform scale-95 animate-fadeIn">
          <button
              onClick={() => setIsOpen(false)}
              className="absolute top-5 right-5 p-2 text-gray-500 hover:text-gray-800 transition-all"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

         
            <div className="flex items-center gap-6">
              <img
                src="https://marketplace.canva.com/EAFmtJTEua8/1/0/1003w/canva-white-and-blue-geometric-business-book-cover-UaW7V8MHJDU.jpg"
                alt="Book Cover"
                className="w-28 h-40 object-cover rounded-lg shadow-lg"
              />
              <div>
                <h2 className="text-2xl font-bold text-gray-900 leading-tight">
                  Basics of English
                </h2>
                <p className="text-gray-500 text-sm mt-1">by John Doe</p>
              </div>
            </div>


            <div className="mt-6 space-y-4 text-gray-700 text-lg">
              <div className="flex justify-between">
                <span>Book Price:</span>
                <span className="font-medium">₹399.99</span>
              </div>
              <div className="flex justify-between">
                <span>Course Fee:</span>
                <span className="font-medium">₹88.88</span>
              </div>
              <div className="flex justify-between text-green-600 font-medium">
                <span>Discount:</span>
                <span>- ₹10.00</span>
              </div>
              <div className="flex justify-between">
                <span>Tax:</span>
                <span className="font-medium">₹0.00</span>
              </div>
              <div className="flex justify-between">
                <span>Delivery Charge:</span>
                <span className="font-medium">₹120.00</span>
              </div>
              <hr className="my-4 border-gray-300" />
              <div className="flex justify-between font-bold text-2xl">
                <span>Total:</span>
                <span className="text-[#19818C]">₹499.00</span>
              </div>
            </div>

          
            <button className="mt-6 w-full bg-gradient-to-r from-[#19818C] to-[#1E94A4] text-white text-lg font-semibold py-3 rounded-xl hover:scale-[1.02] transition-all shadow-lg">
              Proceed to Checkout
            </button>
          </div>
        </div>
      )}
    </>
  );
}
